
import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faFileAlt, faSignOutAlt, faTable, faTimes, faHome, faStepBackward, faTransgender } from "@fortawesome/free-solid-svg-icons";
import { Nav, Badge, Image, Button, Dropdown, Accordion, Navbar } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import { clientId, clientLogo } from "../helper/config";

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const permission = localStorage.getItem('permission')

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary" } = props;
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  const permissionPoint = permission.split('').reduce((x, it) => {
    return parseInt(x) + parseInt(it)
  })

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.Overview.path}>
          <Image src={clientLogo} className="navbar-brand-light" alt={`${clientId}-logo`} />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              {(permissionPoint > 1) &&
                <NavItem title="Quay về" link={Routes.Overview.path} icon={faStepBackward} />
              }

              <NavItem title="Trang chủ" link={Routes.VietlottOverview.path} icon={faHome} />

              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableNavItem eventKey="/vietlott/search/" title="Tra cứu" icon={faFileAlt}>
                <NavItem title="Đơn hàng" link={Routes.VietlottCart.path} />
                <NavItem title="Vé" link={Routes.VietlottTicket.path} />
                <NavItem title="Nhóm chung" link={Routes.VietlottGroup.path} />
              </CollapsableNavItem>

              <CollapsableNavItem eventKey="/vietlott/search/group" title="Mua chung" icon={faTable}>
                <NavItem title="Tạo nhóm" link={Routes.VietlottGroupCreate.path} />
                <NavItem title="Chờ kích hoạt" link={Routes.VietlottGroupPending.path} />
                <NavItem title="Đang góp" link={Routes.VietlottGroupActive.path} />
                <NavItem title="Đã hoàn thành" link={Routes.VietlottGroupCompleted.path} />
                <NavItem title="Trúng thưởng" link={Routes.VietlottGroupRewarded.path} />
                <NavItem title="Đã hủy" link={Routes.VietlottGroupCancelled.path} />
              </CollapsableNavItem>

              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableNavItem eventKey="/vietlott/statistics/" title="Thống kê" icon={faBook}>
                <NavItem title="Vé mới" link={Routes.VietlottWaitingTicket.path} />
                <NavItem title="Vé đã in" link={Routes.VietlottPrintedTicket.path} />
                <NavItem title="Vé đã hoàn thành" link={Routes.VietlottDoneTicket.path} />
                <NavItem title="Vé đã hủy" link={Routes.VietlottDeletedTicket.path} />
                <NavItem title="Thanh toán" link={Routes.VietlottTransactionSummary.path} />
                <NavItem title="Hoàn tiền" link={Routes.VietlottCashBack.path} />
              </CollapsableNavItem>

              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableNavItem eventKey="/vietlott/reward/" title="Trúng thưởng" icon={faBook}>
                <NavItem title="Trúng thưởng nhỏ" link={Routes.VietlottReward.path} />
                <NavItem title="Trúng thưởng lớn" link={Routes.VietlottBigReward.path} />
              </CollapsableNavItem>

              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableNavItem eventKey="/vietlott/result/" title="Kết quả" icon={faFileAlt}>
                <NavItem title="LOTO 5/35" link={Routes.VietlottLotto535Result.path} />
                <NavItem title="Keno" link={Routes.VietlottKenoResult.path} />
                <NavItem title="Power 6/55" link={Routes.VietlottPowerResult.path} />
                <NavItem title="Mega 6/45" link={Routes.VietlottMegaResult.path} />
                <NavItem title="Max3D" link={Routes.VietlottMax3dResult.path} />
                <NavItem title="Max3D Pro" link={Routes.VietlottMax3dProResult.path} />
              </CollapsableNavItem>

              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableNavItem eventKey="/vietlott/period/" title="Kỳ quay" icon={faBook}>
                <NavItem title="Ngày nghỉ" link={Routes.VietlottDayOff.path} />
                <NavItem title="LOTO 5/35" link={Routes.VietlottLotto535Period.path} />
                <NavItem title="Keno" link={Routes.VietlottKenoPeriod.path} />
                <NavItem title="Power 6/55" link={Routes.VietlottPowerPeriod.path} />
                <NavItem title="Mega 6/45" link={Routes.VietlottMegaPeriod.path} />
                <NavItem title="Max3D" link={Routes.VietlottMax3dPeriod.path} />
                <NavItem title="Max3D Pro" link={Routes.VietlottMax3dProPeriod.path} />
              </CollapsableNavItem>
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
